import type { MenuDataItem } from '@umijs/route-utils';
import { request } from '@umijs/max';
import { renderIcon } from '@/components';

export async function getAuthMenus(options?: { [key: string]: any }) {
  const response = await request<
    API.BackendApiResponse<API.AuthMenuListPayload>
  >(
    '/api/auth/menu/tree',
    {
      method: 'GET',
      ...(options || {}),
    },
  );

  return response.data?.list ?? [];
}

export const transformBackendMenus = (
  items: API.AuthMenuItem[] = [],
): MenuDataItem[] => {
  return items
    .map((item) => {
      const children = transformBackendMenus(item.children ?? []);
      const menuItem: MenuDataItem = {
        key: item.code,
        name: item.name,
        path: item.path,
        icon: renderIcon(item.icon),
      };

      if (children.length > 0) {
        menuItem.children = children;
      }

      if (item.isExternal === 1) {
        menuItem.target = '_blank';
      }

      return menuItem;
    })
    .filter((item) => Boolean(item.path) || Boolean(item.children?.length));
};
